<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO_MATRICULAS.REMATRICULAS')"
      :subtitulo="$t('ACADEMICO_MATRICULAS.REMATRICULAS_DESCRICAO_PAGE')"
      :breadcrumbs="breadcrumbs"
    />
    <filtro-rematricula
      :filtro="filtro"
      @limpar="limparFiltro"
      @filtrar="filtrar"
    />

    <div class="d-flex flex-column flex-sm-row justify-content-between py-4">
      <h5>
        {{ $t('ACADEMICO.LISTA_DE_CONTRATOS') }}
      </h5>
      <b-btn-group class="d-flex gap-2 flex-column flex-sm-row">
        <b-btn
          variant="info"
          @click="gerarRematriculas"
          :disabled="contratos.length == 0"
        >
          {{ $t('ACADEMICO.GERAR_REMATRICULA') }} - {{ proximoAno }}
        </b-btn>
        <b-btn
          variant="info"
          @click="gerarAntecipacoes"
          :disabled="contratos.length == 0"
        >
          {{ $t('ACADEMICO.GERAR_ANTECIPACAO') }} - {{ proximoAno }}
        </b-btn>
        <!-- <b-btn
          variant="info"
          @click="ativarContratos"
          :disabled="contratos.length == 0"
        >
          {{ $t('ACADEMICO.ATIVAR_CONTRATOS') }}
        </b-btn>
        <b-btn
          variant="info"
          @click="imprimirContratos"
          :disabled="contratos.length == 0"
        >
          {{ $t('ACADEMICO.IMPRIMIR_CONTRATOS') }}
        </b-btn>
        <b-btn
          variant="info"
          @click="imprimirFichaDeMatricula"
          :disabled="contratos.length == 0"
        >
          {{ $t('ACADEMICO.IMPRIMIR_FICHA_REMATRICULA') }}
        </b-btn> -->
      </b-btn-group>
    </div>

    <tabela-contratos-rematricula :items="contratos" @alterar-ordenacao="novaOrdenacao"/>

    <paginacao v-model="paginacao" :total="paginacao.total" @input="filtrar" />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import pdf from '@/common/utils/pdf';

// Services:
import ContratosService from '@/common/services/contratos/contratos.service';

// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import FiltroRematricula from '@/views/academico/rematriculas/components/FiltroRematricula';
import TabelaContratosRematricula from '@/views/academico/rematriculas/components/TabelaContratosRematricula';

import Paginacao from '@/components/paginacao/Paginacao';

export default {
  name: 'rematriculas',
  components: {
    Topbar,
    Paginacao,
    FiltroRematricula,
    TabelaContratosRematricula,
  },
  data() {
    return {
      proximoAno: new Date().getFullYear() + 1,
      contratos: [],
      filtro: {
        tipoFiltro: '',
        matriculaId: '',
        cursoId: '',
        grupoTurmaId: '',
        turmaId: '',
        tipoContrato: null,
        somentePagamentosEmDia: false,
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.REMATRICULAS') },
      ],
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted(){
    this.filtrar(); 
  },
  methods: {
    //  rematricula
    gerarRematriculas() {
      if (this.contratos.length === 0) return;
      this.$store.dispatch(START_LOADING);
      ContratosService.gerarRematricula(this.filtro)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    gerarAntecipacoes() {
      if (this.contratos.length === 0) return;
      this.$store.dispatch(START_LOADING);
      ContratosService.gerarAntecipacaoAnuidade(this.filtro)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    imprimirContratos() {
      this.$store.dispatch(START_LOADING);
      ContratosService.imprimirContratosRematricula(this.filtro)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    imprimirFichaDeMatricula() {
      this.$store.dispatch(START_LOADING);
      ContratosService.imprimirFichaDeMatricula(this.filtro)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);

            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    ativarContratos() {
      this.$store.dispatch(START_LOADING);
      ContratosService.ativarContratos(this.filtro)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // filtro
    filtrar() {
      this.$store.dispatch(START_LOADING);
      ContratosService.obterContratosParaRematricula(
        this.filtro,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.contratos = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          this.contratos = [];
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    limparFiltro() {
      const filtro = this.filtro.tipoFiltro
      this.filtro = {
        tipoFiltro: filtro,
        matriculaId: '',
        curso: '',
        grupoTurma: '',
        turma: '',
        tipoContrato: null,
        somentePagamentosEmDia: false,
      }

    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.filtrar(); 
    },
  },
};
</script>

<style scoped>
.gap {
  gap: 10px;
}
.btn:disabled {
  cursor: not-allowed;
}
</style>
